import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CiudadDTO } from 'src/app/pago/dtos/CiudadDTO.model';
import { ResponseCiudad } from 'src/app/pago/models/ResponseCiudad.model';
import { DepartamentoDTO } from 'src/app/pago/dtos/DepartamentoDTO.model';
import { ResponseDepartamento } from 'src/app/pago/models/ResponseDepartamento.model';

@Injectable({
  providedIn: 'root',
})
export class MaestrosService {
  constructor(private httpClient: HttpClient) {}

  getTiposDeDocumento<T>(): Observable<T> {
    return this.httpClient.get<T>(
      `${environment.maestrosApi}/persona/documento`
    );
  }

  getCiudades(): Observable<CiudadDTO[]> {
    return this.httpClient
      .get<ResponseCiudad>(`${environment.maestrosApi}/ciudades`)
      .pipe(map((response: ResponseCiudad) => response.ciudades));
  }

  getDepartamentos(): Observable<DepartamentoDTO[]> {
    return this.httpClient
      .get<ResponseDepartamento>(`${environment.maestrosApi}/departamentos`)
      .pipe(map((response: ResponseDepartamento) => response.departamentos));
  }
}
